import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { LicenseComponent } from '@app/authentication/license/license.component';
import { DbmFileUploadModule } from '@app/shared/components/dbm-components/dbm-file-upload/dbm-file-upload.module';

@NgModule({
    imports: [SharedModule, DbmFileUploadModule],
    declarations: [LicenseComponent],
    exports: [LicenseComponent],
    entryComponents: [LicenseComponent],
})
export class LicenseModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authentication/license/license.module.ts